import { createContext } from 'react';

type Theme = 'light';

export interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'light';
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
